<div class="session bg-primary">
  <div class="session-content" >
    <div class="flex-box flex-box-monkey">
      <img src="assets/images/monkey-1.png" alt="Monkey" title="Monkey" class="monkey-1" />
      <img src="assets/images/monkey-2.png" alt="Monkey" title="Monkey" class="monkey-2" />
      <mat-card class="mat-card-flat flex-card width-card">
        <mat-card-content>
          <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="form">
            <div class="text-xs-center pb-1">
              <img src="assets/images/logo.png" alt="Smart contact" title="Smart contact" width="150" />
              <div class="full-width mt-1">
                <div class="full-width" *ngIf="signinStep === 2">
                  <button type="button" data-ci="filed_username" mat-stroked-button (click)="backLogin()" tabindex="4">
                    <span class="font-weight-bold">{{ username }}</span>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                  </button>
                </div>
                <ng-container *ngIf="domainName && enterpriseName">
                  <h2 class="domain-name mt-1"
                    [innerHTML]=" 'login.login_domain' | translate:{ domain: enterpriseName } "></h2>
                  <a data-ci="change-domain" (click)="backLogin(true)"
                    class="mat-text-primary d-inline link-signin">{{ 'menu.connect_other_enterprise_hint' | translate }}</a>
                </ng-container>
                <p class="mat-error mb-0" *ngIf="errorMessage" data-ci="error-message">{{ errorMessage }}</p>
              </div>
            </div>

            <div fxLayout="column" fxLayoutAlign="space-around">
              <div class="pb-1" *ngIf="signinStep === 1">
                <input id="username" matInput #username [placeholder]="'login.user'|translate"
                  [formControl]="form.controls['username']" tabindex="1" focus="true">
                <small *ngIf="form.controls['username'].invalid && form.controls['username'].touched"
                    [flexFormControlError]="form.controls['username']"
                    [customMessages]="{
                      'required': 'login.validators.username_required' | translate
                    }"
                  class="mat-text-warn ml-10"></small>
              </div>
              <ng-container *ngIf="signinStep === 2">
                <div class="pb-1">
                  <input id="password" matInput #password type="password" [placeholder]="'login.pass'|translate"
                    [formControl]="form.controls['password']" tabindex="1" focus="true">
                  <small *ngIf="form.controls['password'].invalid && form.controls['password'].touched"
                    [flexFormControlError]="form.controls['password']"
                    [customMessages]="{
                      'required': 'login.validators.password_required' | translate
                    }"
                    class="mat-text-warn ml-10"></small>
                </div>
                <div *ngIf="hasPasswordManager" class="pb-1">
                  <mat-checkbox formControlName="savePassword" tabindex="2">{{ 'login.save_password'|translate }}
                  </mat-checkbox>
                </div>
              </ng-container>

              <ng-container *ngIf="mfaRequired">
                <div class="pb-1">
                  <input id="mfa_code" matInput [placeholder]="'login.mfa_code'|translate"
                    [formControl]="form.controls['mfa_code']" tabindex="1" focus="true">

                  <small *ngIf="form.controls['mfa_code'].invalid && form.controls['mfa_code'].touched"
                    [flexFormControlError]="form.controls['mfa_code']"
                    class="mat-text-warn ml-10"></small>
                </div>
              </ng-container>

              <button data-ci="login" mat-raised-button class="login-button gradient-background" type="submit"
                [disabled]="!canSubmit()" tabindex="3">{{ 'login.login' | translate }}</button>
            </div>

            <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="20px" class="mt-1"
              *ngIf="isProjectAdmin">
              <button [attr.data-ci]="'btn-oauth-' + oAuthType.name" mat-stroked-button mat-raised-button
                *ngFor="let oAuthType of oAuthTypes" (click)="doOAuth(oAuthType.uri)" [title]="oAuthType.name"
                class="oauth-type full-width">
                <img src="assets/images/{{oAuthType.logo}}" width="80px">
              </button>
            </div>

            <div class="pt-1 text-xs-center" *ngIf="domainName && enterpriseName">
              <a data-ci="forgot" [routerLink]="['/s/forgot']"
                class="link-signin mat-text-primary">{{ 'login.forgot_password' | translate }}</a>
            </div>
            <div class="pt-1 pb-1 text-xs-center">
              <a *ngIf="!isProjectSuperAdmin && isDevMode" (click)="signUp()"
                class="link-signin">{{ 'login.create_new_account' | translate }}</a>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
